export enum EnvType {
    DEV = 'DEV',
    PROD = 'PROD'
}

export enum Format {
    IsoDate = 'yyyy-MM-dd',
    DateFormat = 'dd.MM.yyyy',
    MomentFormat = 'DD.MM.YYYY',
    HistoryDateFormat = 'dd.MMM',
    SimpleTime = 'HH:mm',
    MonthFormat = 'MMMM yyyy',
    DateTimeFormat = 'dd.MM.yyy HH:mm'
}

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+$/
export const PASSWORD_REGEX = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?([^\w\s]|[_])).{8,}$/
export const PHONE_REGEX = /^([+][0-9]{1,3}[ .-])?([(]{1}[0-9]{1,6}[)])?([0-9 .\-/]{3,20})((x|ext|extension)[ ]?[0-9]{1,4})?$/
export const POSTAL_CODE_REGEX = /^[0-9]{5}$/
export const INSURANCE_NUMBER_REGEX = /^[a-zA-Z][0-9]{9}$/
export const URL_REGEX = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([a-zA-Z0-9@:%_\\+.~#()?&/=]*)$/
export const FLOATING_NUMBER= /^([0-9]*[.,])?[0-9]+$/
export const INTEGER_NUMBER =  /^([+-]?[1-9]\d*|0)$/

/**
 * This value is used for checking if the token expires within this timeframe.
 * This value is measured in seconds.
 */
export const TOKEN_MIN_VALIDITY = 50
